import { Root, Grid } from './calendar';
import { TimeSlots, BookAction, EmptyMonth } from './calendar-booking';

export const Calendar = { Root, Grid, TimeSlots, BookAction, EmptyMonth };

export { DayButton, dayButtonVariants, resolveState } from './day-button';
export type { DayButtonState } from './day-button';
export { dispatchSelect } from './calendar';
export { findSameSlot, isSlotFull, toDateKey } from './calendar-utils';
export type {
  CalendarSlot,
  CalendarAvailability,
  CalendarRootProps,
  CalendarGridProps,
  CalendarTimeSlotsProps,
  CalendarBookActionProps,
  CalendarEmptyMonthProps,
  CalendarMode,
  DateRange,
} from './calendar.types';
export { useCalendarContext, useBookingContext } from './calendar-context';
